import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Milestone from '../../entities/milestone';
export function deleteMilestone(milestone: Milestone, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = milestone.id;}
const _work = workingSet();




milestone.status = 'D';
milestone.addedOn = newHRTimestamp();
milestone.addedBy = getCurrentUserId();
milestone.importSource = targetImportSource;
milestone.importId = mergeId;
store.dispatch(Actions.MilestoneActions.removeMilestoneQueue(milestone));
}


